import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/common/ScrollToTop";

// Public Pages
import HomePage from "./pages/HomePage";
import CompaniesPage from "./pages/CompaniesPage";
import CompanyDetailPage from "./pages/CompanyDetailPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import EhiaaInitiativePage from "./pages/EhiaaInitiativePage";
import ApplicationsPage from "./pages/ApplicationsPage";
import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import BoardPage from "./pages/BoardPage";
import CareersPage from "./pages/CareersPage";
import JobApplicationPage from "./pages/JobApplicationPage";
import ContactPage from "./pages/ContactPage";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminSliders from "./pages/admin/AdminSliders";
import AdminCompanies from "./pages/admin/AdminCompanies";
import AdminProjects from "./pages/admin/AdminProjects";
import AdminEhiaaInitiative from "./pages/admin/AdminEhiaaInitiative";
import AdminApplications from "./pages/admin/AdminApplications";
import AdminNews from "./pages/admin/AdminNews";
import AdminBoard from "./pages/admin/AdminBoard";
import AdminJobs from "./pages/admin/AdminJobs";
import AdminJobApplications from "./pages/admin/AdminJobApplications";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminAdmins from "./pages/admin/AdminAdmins";
import AdminSettings from "./pages/admin/AdminSettings";

// Layout
import PublicLayout from "./components/layout/PublicLayout";
import AdminLayout from "./components/layout/AdminLayout";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/companies/:slug" element={<CompanyDetailPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:slug" element={<ProjectDetailPage />} />
              <Route path="/ehiaa" element={<EhiaaInitiativePage />} />
              <Route path="/applications" element={<ApplicationsPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/news/:slug" element={<NewsDetailPage />} />
              <Route path="/board" element={<BoardPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/careers/:jobId/apply" element={<JobApplicationPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="sliders" element={<AdminSliders />} />
              <Route path="companies" element={<AdminCompanies />} />
              <Route path="projects" element={<AdminProjects />} />
              <Route path="ehiaa" element={<AdminEhiaaInitiative />} />
              <Route path="applications" element={<AdminApplications />} />
              <Route path="news" element={<AdminNews />} />
              <Route path="board" element={<AdminBoard />} />
              <Route path="jobs" element={<AdminJobs />} />
              <Route path="job-applications" element={<AdminJobApplications />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="admins" element={<AdminAdmins />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
